import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import '../../atoms/buttons/enums.js';
import '../../utilities/dom-helpers/index.js';
import { lineClamp } from '../../utilities/text-helpers/index.js';
import { imgLazyLoadingResolver } from '../../../common/img-lazy-loading-resolver.js';
import css_248z from './social-proof-plus-item.scss.js';

let uidCounter = 0;
class SocialProofPlusItem extends s {
    constructor() {
        super(...arguments);
        this._titleId = (() => {
            uidCounter += 1;
            return `social-proof-plus-item-title-${uidCounter}`;
        })();
        this.name = '';
        this.position = '';
        this.paragraph = '';
        this.imageUrl = '';
        this.imageAlt = '';
    }
    get truncatedParagraph() {
        return lineClamp(this.paragraph, 210);
    }
    firstUpdated() {
        imgLazyLoadingResolver(this.renderRoot);
    }
    _renderCta() {
        if (!this.ctaUrl)
            return '';
        if (this.ctaAriaLabel) {
            return $ `<generic-button-updated class="social-proof-plus-item__cta key-feature-card-button" type="tertiary" styleType="light" color="purple" label="${this.ctaLabel}" href="${this.ctaUrl}" target="${this.ctaTarget || ''}" .ariaList="${{ 'aria-label': this.ctaAriaLabel }}"></generic-button-updated>`;
        }
        return $ `<generic-button-updated class="social-proof-plus-item__cta key-feature-card-button" type="tertiary" styleType="light" color="purple" label="${this.ctaLabel}" href="${this.ctaUrl}" target="${this.ctaTarget || ''}"></generic-button-updated>`;
    }
    render() {
        return $ `<div class="social-proof-plus-item"><article class="social-proof-plus-item__article" aria-labelledby="${this._titleId}"><div class="social-proof-plus-item__header"><img src="${this.imageUrl}" alt="${this.imageAlt}" width="96" height="96" loading="lazy"></div><div class="social-proof-plus-item__body"><div class="social-proof-plus-item__author"><h3 id="${this._titleId}" class="social-proof-plus-item__name">${this.name}</h3><p class="social-proof-plus-item__position">${this.position}</p></div><p class="social-proof-plus-item__paragraph">${this.truncatedParagraph}</p>${this._renderCta()}</div></article></div>`;
    }
}
SocialProofPlusItem.styles = css_248z;
__decorate([
    e({ type: String })
], SocialProofPlusItem.prototype, "name", void 0);
__decorate([
    e({ type: String })
], SocialProofPlusItem.prototype, "position", void 0);
__decorate([
    e({ type: String })
], SocialProofPlusItem.prototype, "paragraph", void 0);
__decorate([
    e({ type: String })
], SocialProofPlusItem.prototype, "imageUrl", void 0);
__decorate([
    e({ type: String })
], SocialProofPlusItem.prototype, "imageAlt", void 0);
__decorate([
    e({ type: String })
], SocialProofPlusItem.prototype, "ctaUrl", void 0);
__decorate([
    e({ type: String })
], SocialProofPlusItem.prototype, "ctaLabel", void 0);
__decorate([
    e({ type: String })
], SocialProofPlusItem.prototype, "ctaAriaLabel", void 0);
__decorate([
    e({ type: String })
], SocialProofPlusItem.prototype, "ctaTarget", void 0);
__decorate([
    e({ type: Boolean })
], SocialProofPlusItem.prototype, "ctaIsNoFollow", void 0);
customElements.define('social-proof-plus-item', SocialProofPlusItem);

export { SocialProofPlusItem };
